<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('earners')">
            <app-default-button
                    :title="$addLabel('earner')"
                    @click="openModal"
            />
        </app-page-top-section>

        <app-table
                id="earner-table"
                :options="options"
                @action="triggerActions"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('earner-table')"
                @cancelled="confirmationModalActive = false"
        />

        <app-earner-create-edit
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
        />

    </div>
</template>

<script>
    import {EARNERS} from "../../../Config/ApiUrl";
    import {actionColumn, htmlColumn, textColumn} from "../../../Helpers/TableCommonColumn";
    import {createdFilter} from "../../../Helpers/TableFIlter";
    import {deleteAction, editAction} from "../../../Helpers/TableAction";
    import DatatableHelperMixin from "../../../Mixins/DatatableHelperMixin";

    export default {
        name: "Banners",
        mixins: [DatatableHelperMixin],
        data() {
            return {
                options: {
                    name: this.$allLabel('earners'),
                    url: EARNERS,
                    responsive: true,
                    columns: [
                        textColumn(this.$t('rank'), 'rank'),
                        textColumn(this.$t('rank_text'), 'rank_text'),
                        textColumn(this.$t('name'), 'name'),
                        htmlColumn(this.$t('image'), 'image', image => {
                            return `<img src="${image}" alt="Banner" style="height: 50px; width: auto" />`;
                        }),
                        actionColumn(),
                    ],
                    filters: [
                        createdFilter()
                    ],
                    actionType: "dropdown",
                    actions: [
                        editAction(this.$can('update_earners'), EARNERS),
                        deleteAction(this.$can('delete_earners'), EARNERS),
                    ],
                    rowLimit: 10,
                    paginationType: "pagination"
                },
                isModalActive: false,
                selectedUrl: ''
            }
        },
        methods: {
            openModal() {
                this.isModalActive = true;
                this.selectedUrl = '';
            },
            triggerActions(row, action, active) {
                if (action.key === 'edit') {
                    this.isModalActive = true;
                    this.selectedUrl = `${this.apiUrl.EARNERS}/${row.id}`
                }else if (action.name === 'delete') {
                    this.delete_url =  `/${this.apiUrl.EARNERS}/${row.id}`
                    this.confirmationModalActive = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>